import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { IRegionTag } from '@cbgms/api'
import { useNotifier } from '@cbgms/base/notifier'
import RegionForm from 'gms-support/src/app-support/regions/components/RegionForm'
import { createRegionTag } from 'gms-support/src/app-support/regions/state/actions'

const initialNewRegion = {
  UUID: '',
  Name: '',
  CmsSystem: '',
  CmsURL: '',
  CMSDrupalOverride: '',
  Country: '',
  CreatedAt: '',
  UpdatedAt: ''
}

const NewRegion = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const notifier = useNotifier()
  const history = useHistory()

  const onSubmit = async (values: IRegionTag) => {
    try {
      const { UUID: _, CreatedAt: __, UpdatedAt: ___, ...newValues } = values
      const {
        Data: { UUID }
      } = await dispatch(createRegionTag(newValues))

      return { ...values, UUID }
    } catch (error) {
      throw error
    }
  }

  const onSubmitSuccess = async (v: IRegionTag) => {
    notifier.success(t('bank_holidays.successfully_created'))
    history.push(`/regions/edit/${v.UUID}`)
  }

  return (
    <RegionForm
      headerText='bank_holidays.new_region'
      onSubmit={onSubmit}
      onSubmitSuccess={onSubmitSuccess}
      form='new_region_tag'
      initialValues={initialNewRegion}
    />
  )
}

export default NewRegion
